import { Link } from "@tanstack/react-router";
import { Star } from "lucide-react";
import { GOOGLE_RATING } from "./constants";

export function GoogleRatingLine({ className = "" }: { className?: string }) {
  return (
    <Link
      to="/reviews"
      className={`inline-flex items-center gap-1.5 text-sm font-semibold hover:underline ${className}`}
    >
      <Star className="size-4 fill-current text-cta" aria-hidden="true" />
      {GOOGLE_RATING.rating} stars on Google, {GOOGLE_RATING.count} reviews
    </Link>
  );
}
